module.exports = __webpack_public_path__ + "media/images/photos/woman-with-headset-dca275bdb54d867f00edb97fb23da2ae.jpg";